import React, { ReactNode } from "react"
import { Navigate } from "react-router"
import { useSelectedProfileId } from "../../app/hooks"

interface IProtectedRouteProps {
  children: ReactNode
}

export const ProtectedRoute: React.FC<IProtectedRouteProps> = ({
  children,
}) => {
  const user = useSelectedProfileId()

  if (!user) {
    return <Navigate to="/user-selection" />
  }

  return <>{children}</>
}
